// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3P5uX","question":"styles_question__1OfXS","inputVisibleButton":"styles_inputVisibleButton__2XWxV","note":"styles_note__ZVa_x"};